module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "condominium-box mb-3 pt-3 pb-2 pl-3 pr-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('h6', [_vm._v("Comunicação")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.scheduleDone),
      expression: "!scheduleDone"
    }]
  }, [_c('iframe', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "printf",
      "id": "printf"
    },
    on: {
      "load": _vm.frameLoaded
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.loadingScheduleActions,
      "flat": "",
      "color": "blue darken-3"
    },
    on: {
      "click": _vm.print
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("print")]), _vm._v(" imprimir comunicado")], 1)], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.scheduleDone),
      expression: "!scheduleDone"
    }],
    attrs: {
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), (_vm.scheduleDone && _vm.schedule.sent) ? _c('v-flex', [_c('p', {
    staticClass: "green--text mt-2"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "color": "green"
    }
  }, [_vm._v("check")]), _vm._v("\n     " + _vm._s(_vm.schedule.unitCount) + " unidades notificadas e " + _vm._s(_vm.schedule.condominiumsCount + _vm.schedule.sindicatesCount) + " e-mails enviados\n   ")], 1)]) : (_vm.scheduleDone && !_vm.schedule.sent) ? _c('v-flex', [_c('p', {
    staticClass: "mt-3"
  }, [_vm._v("\n      Não foi divulgado nenhum email para os condôminos\n    ")])]) : (_vm.schedule.sent) ? _c('v-flex', [_c('p', {
    staticClass: "green--text mt-2"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "color": "green"
    }
  }, [_vm._v("check")]), _vm._v("\n      " + _vm._s(_vm.schedule.unitCount) + " unidades notificadas e " + _vm._s(_vm.schedule.condominiumsCount + _vm.schedule.sindicatesCount) + " e-mails enviados\n   ")], 1)]) : _c('v-flex', {}, [_c('v-btn', {
    attrs: {
      "disabled": _vm.loadingScheduleActions,
      "flat": "",
      "color": "blue darken-3"
    },
    on: {
      "click": function($event) {
        _vm.sendEmailModal = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2"
  }, [_vm._v("email")]), _vm._v(" Divulgar este agendamento via e-mail")], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "full-width": "",
      "max-width": "933"
    },
    model: {
      value: (_vm.sendEmailModal),
      callback: function($$v) {
        _vm.sendEmailModal = $$v
      },
      expression: "sendEmailModal"
    }
  }, [_c('v-card', {
    staticClass: "pl-5 pr-5 no-details"
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-4 pb-3"
  }, [_c('v-flex', [_c('h6', [_vm._v("\n              Comunicado para o condômino\n            ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendEmailModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('p', [_vm._v("\n                Estamos enviando um email ao gerente e síndico do condomínio para que autorize a comunicação aos condôminos. Após a autorização, o disparo dos e-mails aos condôminos será automático.\n                ")]), _vm._v(" "), _c('p', [_c('strong', {
    staticClass: "red--text"
  }, [_vm._v("ATENÇÃO")]), _vm._v(": o envio deste e-mail será realizado APENAS UMA VEZ. Tenha CERTEZA que o agendamento no condomínio está confirmado.\n              ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "round": "",
      "outline": "",
      "dark": "",
      "color": "green"
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("Enviar")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb7a72c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/agendamento/SendEmail.vue
// module id = 514
// module chunks = 0 1